import React, { useState, useEffect } from "react";
import { fetchEstatisticas } from "../../api/apiService";
import Navbar from "../../components/Navbar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  Button,
  Typography,
  Box,
  Modal,
  TextField,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  Pagination,
  IconButton,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

const Estatisticas = () => {
  const [estatisticas, setEstatisticas] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [statusSlideIndex, setStatusSlideIndex] = useState(0);
  const [categoriaSlideIndex, setCategoriaSlideIndex] = useState(0);
  const [statusFilter] = useState("TODOS");
  const [filteredSolicitacoes, setFilteredSolicitacoes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([
    "CONSULTA",
    "EXAME",
    "TRANSPORTE",
  ]);
  const [selectAll, setSelectAll] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState([
    "PENDENTE",
    "ACEITO",
    "NEGADO",
  ]); // Status inicial padrão
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(filteredSolicitacoes.length / itemsPerPage);
  const paginatedData = filteredSolicitacoes.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const [subcategorias, setSubcategorias] = useState([]);
  const [selectedSubcategorias, setSelectedSubcategorias] = useState([]);
  const options = subcategorias.map((sub) => ({ value: sub, label: sub }));
  const [filterStatus, setFilterStatus] = React.useState("TODOS");
  const getStatusColor = (status) => {
    switch (status) {
      case "PENDENTE":
        return "#fff3cd"; // Amarelo claro
      case "ACEITO":
        return "#d4edda"; // Verde claro
      case "NEGADO":
        return "#f8d7da"; // Vermelho claro
      default:
        return "#f1f1f1"; // Cinza claro
    }
  };
  const [isLoading, setIsLoading] = useState(false);
  const [porConclusao, setPorConclusao] = useState(false);

  useEffect(() => {
    if (estatisticas && selectedCategories.length > 0) {
      const subcategoriasFiltradas = estatisticas.historicoRecentes
        .filter((item) => selectedCategories.includes(item.categoria))
        .map((item) => item.nomeServico)
        .filter((value, index, self) => self.indexOf(value) === index); // Remove duplicados
      setSubcategorias(subcategoriasFiltradas);
      setSelectedSubcategorias(subcategoriasFiltradas); // Seleciona tudo por padrão
    } else {
      setSubcategorias([]);
      setSelectedSubcategorias([]);
    }
  }, [selectedCategories, estatisticas]);

  useEffect(() => {
    if (estatisticas) {
      if (statusFilter === "TODOS") {
        setFilteredSolicitacoes(estatisticas.historicoRecentes);
      } else {
        setFilteredSolicitacoes(
          estatisticas.historicoRecentes.filter(
            (item) => item.status === statusFilter
          )
        );
      }
    }
  }, [statusFilter, estatisticas]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const toggleStatus = (status) => {
    if (selectedStatus.includes(status)) {
      setSelectedStatus(selectedStatus.filter((s) => s !== status));
    } else {
      setSelectedStatus([...selectedStatus, status]);
    }
  };

  const carregarEstatisticas = async (porConclusaoAtualizado) => {
    setIsLoading(true); // Ativa o estado de carregamento
    try {
      const data = await fetchEstatisticas(
        `${startDate.toISOString().split("T")[0]}T00:00:00`,
        `${endDate.toISOString().split("T")[0]}T23:59:59`,
        porConclusaoAtualizado
      );
      setEstatisticas(data);
    } catch (error) {
      setEstatisticas(null);
    } finally {
      setIsLoading(false); // Desativa o estado de carregamento
    }
  };

  const toggleCategory = (category) => {
    if (selectedCategories.includes(category)) {
      setSelectedCategories(
        selectedCategories.filter((cat) => cat !== category)
      );
    } else {
      setSelectedCategories([...selectedCategories, category]);
    }
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedCategories([]);
    } else {
      setSelectedCategories(["CONSULTA", "EXAME", "TRANSPORTE"]);
    }
    setSelectAll(!selectAll);
  };

  const formatDate = (dateString, onlyDate = false) => {
    if (!dateString) return "Sem Data";
  
    // Se a data estiver no formato "YYYY-MM-DD", adiciona um horário "00:00:00" apenas para exibição correta
    let dateObject = dateString.includes("T") ? new Date(dateString) : new Date(`${dateString}T00:00:00`);
  
    return dateObject.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      ...(onlyDate ? {} : { hour: "2-digit", minute: "2-digit", second: "2-digit" })
    });
  };
  

  const gerarPDF = () => {
    const doc = new jsPDF();

    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString();
    const formattedTime = currentDate.toLocaleTimeString();
    const generatedBy = localStorage.getItem("nome") || "Usuário Desconhecido";
    const location = "Vicência";

    // Cabeçalho
    doc.setFontSize(22);
    doc.text("Histórico de Serviços", 105, 15, { align: "center" });
    doc.setFontSize(12);
    doc.text(`Gerado por: ${generatedBy}`, 14, 25);
    doc.text(`Data de Geração: ${formattedDate} ${formattedTime}`, 14, 30);
    doc.text(`Local: ${location}`, 14, 35);

    doc.line(14, 40, 196, 40); // Linha separadora

    let currentY = 45; // Posição inicial do conteúdo

    selectedCategories.forEach((category) => {
      const categoryData = filteredSolicitacoes.filter(
        (item) =>
          item.categoria &&
          item.categoria.toUpperCase() === category &&
          selectedSubcategorias.includes(item.nomeServico) && // Filtro por subcategorias
          selectedStatus.includes(item.status)
      );

      if (categoryData.length > 0) {
        doc.setFontSize(14);
        doc.text(category, 14, currentY);
        currentY += 10;

        const tableRows = categoryData.map((item) => [
          item.nomePaciente || "N/A",
          item.nomeServico,
          formatStatus(item.status),
          formatDate(item.dataConclusao),
        ]);

        doc.autoTable({
          startY: currentY,
          head: [["Paciente", "Serviço", "Status", "Data de Conclusão"]],
          body: tableRows,
          didParseCell: (data) => {
            if (data.column.index === 2) {
              // Aplica cores dependendo do status
              if (data.cell.raw === "PENDENTE") {
                data.cell.styles.textColor = [128, 128, 128]; // Cinza
              } else if (data.cell.raw === "ACEITO") {
                data.cell.styles.textColor = [0, 128, 0]; // Verde
              } else if (data.cell.raw === "NEGADO") {
                data.cell.styles.textColor = [255, 0, 0]; // Vermelho
              }
            }
          },
        });

        currentY = doc.lastAutoTable.finalY + 10;
      }
    });

    // Rodapé
    doc.setFontSize(10);
    doc.text(
      "Este documento contém informações confidenciais.",
      14,
      doc.internal.pageSize.height - 10
    );

    // Nome do arquivo
    const fileName = `${location}-Solicitacoes-${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}.pdf`;
    doc.save(fileName);
    setShowModal(false);
  };

  const formatStatus = (status) => {
    switch (status) {
      case "PENDENTE":
        return "PENDENTE";
      case "ACEITO":
        return "ACEITO";
      case "NEGADO":
        return "NEGADO";
      default:
        return "";
    }
  };

  const nextSlide = (type) => {
    if (type === "status") {
      setStatusSlideIndex((prev) => (prev + 1) % 3);
    } else if (type === "categoria") {
      setCategoriaSlideIndex((prev) => (prev + 1) % 3);
    }
  };

  const prevSlide = (type) => {
    if (type === "status") {
      setStatusSlideIndex((prev) => (prev - 1 + 3) % 3);
    } else if (type === "categoria") {
      setCategoriaSlideIndex((prev) => (prev - 1 + 3) % 3);
    }
  };

  const statusLabels = ["Pendente", "Aceito", "Negado"];
  const categoriaLabels = ["Consulta", "Exame", "Transporte"];

  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    setFilterStatus(selectedStatus);

    if (selectedStatus === "TODOS") {
      // Quando selecionado "Todos", mostra todas as solicitações
      setFilteredSolicitacoes(estatisticas.historicoRecentes);
    } else {
      // Filtra as solicitações pelo status selecionado
      setFilteredSolicitacoes(
        estatisticas.historicoRecentes.filter(
          (item) => item.status === selectedStatus
        )
      );
    }

    // Reseta a página para 1 ao aplicar o filtro
    setCurrentPage(1);
  };

  return (
    <Box
      sx={{
        bgcolor: "#f5f5f5",
        minHeight: "100vh",
        p: 4,
        marginTop: "7vh",
        "@media (max-width: 720px)": {
          marginTop: "5vh",
          p: 2, // Reduz padding no mobile
        },
      }}
    >
      <Box
        sx={{
          bgcolor: "#fff",
          borderRadius: 2,
          p: 4,
          boxShadow: 3,
          maxWidth: "900px", // Limita a largura no desktop
          mx: "auto",
          "@media (max-width: 720px)": {
            p: 3, // Ajusta padding no mobile
          },
        }}
      >
        <Navbar />

        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 3 }}>
          <Button
            variant="contained"
            onClick={() => {
              const today = new Date();
              const threeDaysAgo = new Date(today);
              threeDaysAgo.setDate(today.getDate() - 3);
              setStartDate(threeDaysAgo);
              setEndDate(today);
            }}
          >
            Últimos 3 Dias
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              const today = new Date();
              const sevenDaysAgo = new Date(today);
              sevenDaysAgo.setDate(today.getDate() - 7);
              setStartDate(sevenDaysAgo);
              setEndDate(today);
            }}
          >
            Última Semana
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              const today = new Date();
              const firstDayOfLastMonth = new Date(
                today.getFullYear(),
                today.getMonth() - 1,
                1
              );
              const lastDayOfLastMonth = new Date(
                today.getFullYear(),
                today.getMonth(),
                0
              );
              setStartDate(firstDayOfLastMonth);
              setEndDate(lastDayOfLastMonth);
            }}
          >
            Mês Passado
          </Button>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 2,
            alignItems: "center",
            mb: 3,
            "@media (max-width: 600px)": {
              flexDirection: "column", // Empilha os elementos no celular
            },
          }}
        >
          {/* Input de Data de Início */}
          <Box sx={{ width: "200px" }}>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)} // Atualiza o estado
              dateFormat="dd/MM/yyyy" // Define o formato de exibição
              customInput={
                <TextField
                  fullWidth
                  label="Data de Início" // Label semelhante ao MUI
                  variant="outlined"
                />
              }
            />
          </Box>

          {/* Input de Data Fim */}
          <Box sx={{ width: "200px" }}>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)} // Atualiza o estado
              dateFormat="dd/MM/yyyy" // Define o formato de exibição
              customInput={
                <TextField
                  fullWidth
                  label="Data Fim" // Label semelhante ao MUI
                  variant="outlined"
                />
              }
            />
          </Box>
          {filteredSolicitacoes.length > 0 && (
            <Button
              variant="outlined"
              startIcon={<i className="fas fa-file-pdf" />}
              onClick={() => setShowModal(true)}
            >
              Baixar PDF
            </Button>
          )}
          <Box
            sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 3 }}
          >
            <Button
              variant={!porConclusao ? "contained" : "outlined"}
              color="primary"
              onClick={() => {
                setPorConclusao(false);
                carregarEstatisticas(false);
              }}
              disabled={isLoading}
            >
              {isLoading ? "Carregando..." : "Buscar por Data de Solicitação"}
            </Button>

            <Button
              variant={porConclusao ? "contained" : "outlined"}
              color="primary"
              onClick={() => {
                setPorConclusao(true);
                carregarEstatisticas(true);
              }}
              disabled={isLoading}
            >
              {isLoading ? "Carregando..." : "Buscar por Data de Conclusão"}
            </Button>
          </Box>
        </Box>

        <Modal open={showModal} onClose={() => setShowModal(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              borderRadius: 2,
              p: 2,
              width: "280px", // Padrão
              "@media (max-width: 600px)": {
                width: "95%", // Ajusta para telas pequenas
              },
            }}
          >
            <Typography
              variant="h6"
              textAlign="center"
              gutterBottom
              sx={{ marginBottom: 1 }}
            >
              Todas as Opções
            </Typography>

            {/* Categorias */}
            <Box sx={{ mb: 1 }}>
              <Typography variant="subtitle2" sx={{ marginBottom: 0.5 }}>
                Categorias
              </Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectAll}
                      onChange={toggleSelectAll}
                      color="primary"
                      size="small"
                    />
                  }
                  label="Todos"
                />
                {["CONSULTA", "EXAME", "TRANSPORTE"].map((category) => (
                  <FormControlLabel
                    key={category}
                    control={
                      <Checkbox
                        checked={selectedCategories.includes(category)}
                        onChange={() => toggleCategory(category)}
                        color="primary"
                        size="small"
                      />
                    }
                    label={category}
                  />
                ))}
              </Box>
            </Box>

            {/* Subcategorias */}
            <Box sx={{ mb: 1 }}>
              <Typography variant="subtitle2" sx={{ marginBottom: 0.5 }}>
                Subcategorias
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  multiple
                  value={selectedSubcategorias}
                  onChange={(e) => setSelectedSubcategorias(e.target.value)}
                  renderValue={(selected) => selected.join(", ")}
                  sx={{ fontSize: "0.875rem" }}
                >
                  {options.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            {/* Status */}
            <Box>
              <Typography variant="subtitle2" sx={{ marginBottom: 0.5 }}>
                Status
              </Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {["PENDENTE", "ACEITO", "NEGADO"].map((status) => (
                  <FormControlLabel
                    key={status}
                    control={
                      <Checkbox
                        checked={selectedStatus.includes(status)}
                        onChange={() => toggleStatus(status)}
                        color="primary"
                        size="small"
                      />
                    }
                    label={status}
                  />
                ))}
              </Box>
            </Box>

            {/* Botões */}
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "space-between",
                gap: 1,
              }}
            >
              <Button
                variant="outlined"
                onClick={() => setShowModal(false)}
                size="small"
                sx={{ flex: 1 }}
              >
                Cancelar
              </Button>
              <Button
                variant="contained"
                onClick={gerarPDF}
                size="small"
                sx={{ flex: 1 }}
              >
                Gerar PDF
              </Button>
            </Box>
          </Box>
        </Modal>

        {estatisticas && (
          <Box>
            {/* Total de Solicitações */}
            <Box
              sx={{
                mt: 4,
                textAlign: "center",
                border: "1px solid #ccc",
                borderRadius: 2,
                p: 2,
              }}
            >
              <Typography variant="h6" gutterBottom>
                Total de Solicitações
              </Typography>
              <Typography variant="h4" color="primary" gutterBottom>
                {estatisticas.totalSolicitacoes || 0}
              </Typography>
            </Box>

            {/* Grupo: Solicitações por Status e Categoria */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 4,
                mt: 4,
                "@media (max-width: 600px)": {
                  flexDirection: "column", // Empilha os elementos no celular
                  gap: 2, // Reduz o espaço entre os elementos
                },
              }}
            >
              {/* Solicitações por Status */}
              <Box
                sx={{
                  flex: 1,
                  textAlign: "center",
                  border: "1px solid #ccc",
                  borderRadius: 2,
                  p: 2,
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Solicitações por Status
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                  }}
                >
                  <IconButton onClick={() => prevSlide("status")}>
                    <FaArrowLeft />
                  </IconButton>
                  <Typography>
                    <strong>{statusLabels[statusSlideIndex]}:</strong>{" "}
                    {estatisticas.solicitacoesPorStatus?.[
                      statusLabels[statusSlideIndex].toUpperCase()
                    ] || 0}
                  </Typography>
                  <IconButton onClick={() => nextSlide("status")}>
                    <FaArrowRight />
                  </IconButton>
                </Box>
              </Box>

              {/* Solicitações por Categoria */}
              <Box
                sx={{
                  flex: 1,
                  textAlign: "center",
                  border: "1px solid #ccc",
                  borderRadius: 2,
                  p: 2,
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Solicitações por Categoria
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                  }}
                >
                  <IconButton onClick={() => prevSlide("categoria")}>
                    <FaArrowLeft />
                  </IconButton>
                  <Typography>
                    <strong>{categoriaLabels[categoriaSlideIndex]}:</strong>{" "}
                    {estatisticas.solicitacoesPorCategoria?.[
                      categoriaLabels[categoriaSlideIndex].toUpperCase()
                    ] || 0}
                  </Typography>
                  <IconButton onClick={() => nextSlide("categoria")}>
                    <FaArrowRight />
                  </IconButton>
                </Box>
              </Box>
            </Box>

            {/* Histórico de Solicitações Recentes */}
            <Box sx={{ mt: 4 }}>
              {/* Contêiner do título e do filtro */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between", // Título no centro e filtro à direita
                  alignItems: "center",
                  mb: 2,
                }}
              >
                {/* Título centralizado */}
                <Typography
                  variant="h6"
                  sx={{
                    flexGrow: 1, // Faz o título ocupar espaço restante
                    textAlign: "center", // Centraliza o texto
                  }}
                >
                  Histórico de Solicitações Recentes
                </Typography>

                {/* Filtro alinhado à direita */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="body2">Filtrar:</Typography>
                  <FormControl sx={{ minWidth: "120px" }}>
                    <Select
                      value={filterStatus}
                      onChange={handleStatusChange}
                      size="small"
                    >
                      <MenuItem value="TODOS">Todos</MenuItem>
                      <MenuItem value="PENDENTE">Pendente</MenuItem>
                      <MenuItem value="ACEITO">Aceito</MenuItem>
                      <MenuItem value="NEGADO">Negado</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Box>

              {/* Container da Tabela */}
              <TableContainer
                component={Box}
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: 2,
                  overflowX: "auto",
                }}
              >
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <strong>Paciente</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Serviço</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Status</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Data Pedido</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Data Conclusão</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData.map((item) => (
                      <TableRow
                        key={item.id}
                        sx={{
                          backgroundColor: getStatusColor(item.status),
                          "&:hover": {
                            backgroundColor:
                              item.status === "PENDENTE"
                                ? "#ffe9b3" // Cor mais clara para "PENDENTE"
                                : item.status === "ACEITO"
                                ? "#c3e6cb" // Cor mais clara para "ACEITO"
                                : item.status === "NEGADO"
                                ? "#f7c6c7" // Cor mais clara para "NEGADO"
                                : "#e0e0e0", // Cor mais clara para o padrão
                            cursor: "pointer",
                          },
                        }}
                      >
                        <TableCell>{item.nomePaciente}</TableCell>
                        <TableCell>{item.nomeServico}</TableCell>
                        <TableCell>{item.status}</TableCell>
                        <TableCell>
                          {formatDate(item.dataSolicitacao)}
                        </TableCell>
                        <TableCell>
                          {item.dataConclusao
                            ? formatDate(item.dataConclusao, true)
                            : "Sem data de conclusão"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Paginação */}
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(e, value) => handlePageChange(value)}
                color="primary"
                sx={{ mt: 2 }}
              />
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Estatisticas;
